import AuthUtils from '../../../utils/AuthUtils';

export default class Middleware {
  canDisplayRoute(): boolean {
    return !!AuthUtils.resolvePortal();
  }
}
